import { render, staticRenderFns } from "./PlayingFieldItemPage.vue?vue&type=template&id=8f3ba80c&"
import script from "./PlayingFieldItemPage.vue?vue&type=script&lang=js&"
export * from "./PlayingFieldItemPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports